var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2,41.7v-6.2h-7.7V15.4h-4.6v6.4H4V6.3h13.9v6.1h12.4V6.3H44v15.5H30.2v-6.4h-4.7v17.2h4.7v-6.4H44v15.5H30.2z M7,9.3L7,9.3z M33.2,29.1L33.2,29.1z M33.2,9.3L33.2,9.3z M33.2,18.8H41V9.3h-7.8C33.2,9.3,33.2,18.8,33.2,18.8z M33.2,38.7H41v-9.5h-7.8C33.2,29.1,33.2,38.7,33.2,38.7z M7,18.8h7.9V9.3H7L7,18.8L7,18.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise);
export default __webpack_public_path__ + "static/media/expertise.9cfe155f8924186c32a2a169f54ec058.svg";
export { ForwardRef as ReactComponent };